/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useLayoutEffect, useState } from 'react';

export interface Position {
  top: number;
  right: number;
}

export const useAnchorPosition = (
  anchorRef: React.RefObject<HTMLDivElement>,
  active: boolean
) => {
  const [position, setPosition] = useState<Position | null>(null);

  useLayoutEffect(() => {
    if (!anchorRef.current || !active) return undefined;

    const updatePosition = () => {
      const anchor = anchorRef.current;
      if (!anchor) return;

      const rect = anchor.getBoundingClientRect();

      setPosition({
        top: rect.bottom,
        right: window.innerWidth - rect.right,
      });
    };

    updatePosition();

    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', updatePosition, true);

    return () => {
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('scroll', updatePosition, true);
    };
  }, [anchorRef, active]);

  return position;
};
